import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const { fetchDevelopersSuccess, fetchDevelopersFailure } =
  reducer.actions

export const fetchDevelopers = createAction('shop-dev/fetchDevelopers')
export const fetchCSV = createAction('shop-dev/fetchCSV')
